export enum VideoCommandType {
  Start = "start",
  End = "end"
}
